import { FC, useEffect } from 'react';
import { getTreaserAni } from '../../util';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { TopTip } from '@/components/UI/svg/Wave2';

const TreaserA: FC = ({ stage }: any) => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('glacierwave.treaser');
    const { locale } = useRouter();

    useEffect(() => {
        const treaserAni = getTreaserAni();
        treaserAni?.create({
            syncFromTo: [[getTargetCls('.banner-container'), { opacity: 1 }, { opacity: 0 }]],
            triggerElement: getTargetCls('.banner-container'),
            triggerHook: 0,
            offset: '5%',
            duration: 300,
        });

        treaserAni?.create({
            asyncFromTo: [
                [getTargetCls('.ani-controller-first'), { opacity: 0, ease: 'linear' }, { opacity: 1 }, 1],
                [getTargetCls('.img-all'), { opacity: 1, ease: 'linear' }, { opacity: 0 }, 1],
                [getTargetCls('.ani-controller-first'), { opacity: 1, ease: 'linear' }, { opacity: 0 }, 1],
            ],
            asyncTimeLine: [0, 0, 2], // 动画触发事件线
            triggerElement: getTargetCls('.ani-controller-first'),
            triggerHook: 1,
            offset: '5%',
            duration: '55%',
        });

        treaserAni?.create({
            asyncFromTo: [
                [getTargetCls('.ani-controller-second'), { opacity: 0, ease: 'linear' }, { opacity: 1 }, 1],
                [getTargetCls('.img-glacier'), { opacity: 1, ease: 'linear' }, { opacity: 0 }, 1],
                [getTargetCls('.ani-controller-second'), { opacity: 1, ease: 'linear' }, { opacity: 0 }, 1],
            ],
            asyncTimeLine: [0, 0, 2], // 动画触发事件线
            triggerElement: getTargetCls('.ani-controller-second'),
            triggerHook: 1,
            offset: '5%',
            duration: '55%',
        });

        treaserAni?.create({
            asyncFromTo: [
                [getTargetCls('.ani-controller-last'), { opacity: 0, ease: 'linear' }, { opacity: 1 }, 1],
                [getTargetCls('.img-wave2'), { opacity: 1, ease: 'linear' }, { opacity: 0 }, 1],
                [getTargetCls('.ani-controller-last'), { opacity: 1, ease: 'linear' }, { opacity: 0 }, 1],
            ],
            asyncTimeLine: [0, 0, 3], // 动画触发事件线
            triggerElement: getTargetCls('.ani-controller-last'),
            triggerHook: 1,
            offset: '5%',
            duration: '105%',
        });
    }, []);

    return (
        <div className={css.glacierWaveTreaserA}>
            <div className="treaser-img-sticky">
                <div className="treaser-img">
                    {stage === 1 && (
                        <div className="top-tip">
                            <TopTip />
                            <p className="text">{t('top_tip')}</p>
                        </div>
                    )}
                    <div className="img-item img-all-2">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/h5/kv-1.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/h5/kv-1.jpg')}
                        />
                    </div>
                    <div className="img-item img-wave2">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/h5/kv-3.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/h5/kv-3.jpg')}
                        />
                    </div>
                    <div className="img-item img-glacier">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/h5/kv-2.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/h5/kv-2.jpg')}
                        />
                    </div>
                    <div className="img-item img-all">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/h5/kv-1.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/h5/kv-1.jpg')}
                        />
                    </div>
                </div>
            </div>
            <div className="banner-container">
                <div className="ces-img-box">
                    <NextImage webpSrc={require('@publicLocal/ces_2023.webp')} src={require('@publicLocal/ces_2023.png')} />
                </div>
                {/* {stage === 1 && <div className="start-time">{t('living_start_time')}</div>} */}
                {/* <div className="treaser-title">{t('smart_living_title')}</div>
                <div className="treaser-desc">{t('living_description')}</div> */}
                {stage === 1 && (
                    <>
                        <div className="treaser-title">{t('smart_living_title')}</div>
                        <div className="treaser-desc">{t('living_description')}</div>
                    </>
                )}
                {stage !== 1 && locale === 'au' && (
                    <>
                        <div className="treaser-title launch">{t('smart_living_title_launch')}</div>
                        <div className="treaser-desc">{t('living_description_launch')}</div>
                    </>
                )}
            </div>
            <div className="product-intro-wrapper">
                <div className="product-box ani-controller-first">
                    <div className="product-name">{t('product_glacier')}</div>
                    <div className="product-name-line"></div>
                    <div className="product-desc">{t.rich('desc_ice_maker', { line: (text: string) => <div>{text}</div> })}</div>
                </div>
                <div className="product-box ani-controller-second">
                    <div className="product-name">{t('product_wave_two')}</div>
                    <div className="product-name-line"></div>
                    <div className="product-desc">{t.rich('desc_most_powerful', { line: (text: string) => <div>{text}</div> })}</div>
                </div>
                <div className="tip-box ani-controller-last">
                    <div className="tip-text">
                        {locale === 'jp' && <span className="tip-text-tag">「</span>}
                        {t('desc_ces_promising')}
                        {locale === 'jp' && <span className="tip-text-tag">」</span>}
                    </div>
                    <div className="tip-author">{t.rich('author_engadget', { name: (text: string) => <span className="name-underline">{text}</span> })}</div>
                </div>
            </div>
        </div>
    );
};

const getTargetCls = (childCls: string) => `.${css.glacierWaveTreaserA} ${childCls}`;

export default TreaserA;
